import {__} from "./__";

export const getAiFunctionVariableNames = () => {
    return {
        language: __('Jazyk'),
    };
};
